import { StringHelpers } from '@mode/shared/util-js';
import _ from 'lodash';

export function RadioDropdownDirective($timeout, $compile) {
  return {
    scope: {
      dropdownChange: '&',
      dropdownLoading: '<',
      dropdownData: '=',
    },
    link: function (scope, elem, attributes) {
      var element: any = $(elem[0]); // Get the element as a jQuery element

      var templates = {
        filter: $(
          '<div class="multiselect-filter"><input class="form-control multiselect-search next-form-control form-control-sm form-control-block" type="text"><div>'
        ),
        ul: $('<ul uib-dropdown-menu class="multiselect-container dropdown-menu radio-dropdown-menu"></ul>'),
        button: $(
          '<button type="button" class="multiselect dropdown-toggle btn btn-sm next-form-control btn-select" data-test="data-source-selector" uib-dropdown-toggle></button>'
        ),
      };
      var $buttonContainer = $('<div uib-dropdown class="dropdown btn-group" />');

      if (attributes.dropup) {
        $buttonContainer.addClass('dropup');
      }

      if (attributes.block) {
        $buttonContainer.addClass('clearfix');
        templates.button.addClass('btn-block');
      }

      if (attributes.buttonClasses) {
        templates.button.addClass(attributes.buttonClasses);
      }

      if (attributes.appendToBody) {
        $buttonContainer.attr('dropdown-append-to-body', 'true');
      }

      if (attributes.dropdownClasses) {
        templates.ul.addClass(attributes.dropdownClasses);
      }

      if (attributes.autoHeight) {
        templates.ul.attr('select-height', attributes.autoHeight);
      }

      function isUnavailable(text) {
        return text.indexOf('(unavailable)', text.length - '(unavailable)'.length) !== -1;
      }
      function isEveryone(text) {
        return text.indexOf('(everyone)', text.length - '(everyone)'.length) !== -1;
      }
      function isEveryoneAndUnavailable(text) {
        return text.indexOf('(unavailable) (everyone)', text.length - '(unavailable) (everyone)'.length) !== -1;
      }
      function isDeleted(text) {
        return text.indexOf('(Datasource has been removed)') === 0;
      }
      function isError(text) {
        return isUnavailable(text) || isDeleted(text);
      }

      element.multiselect({
        buttonContainer: $buttonContainer,
        maxHeight: attributes.autoHeight ? null : 250,
        buttonWidth: attributes.block ? '100%' : 'auto',
        dropRight: attributes.dropright,
        id: attributes.radioDropdown,
        enableFiltering: !!attributes.radioFilter ? 3 : false,
        enableCaseInsensitiveFiltering: !!attributes.radioFilter,
        filterPlaceholder: 'Find…',
        templates: templates,
        hideEmptyValue: true,
        selectCheckbox: true,
        buttonText: function (options: HTMLOptionsCollection) {
          var text = '';
          const escapedText = StringHelpers.escapeHTML(_.first(options)?.text);
          if (options.length == 0) {
            text = element.data()['placeholder'];
            text = StringHelpers.ellipsize(text, 32);
          } else if (options.length > 1) {
            text = escapedText + ' + ' + (options.length - 1) + ' more selected';
            text = StringHelpers.ellipsize(text, 32);
          } else if (scope.dropdownLoading) {
            text = scope.dropdownLoading;
          } else {
            var text: string = escapedText;
            if (isEveryoneAndUnavailable(text)) {
              text = text.substring(0, text.length - '(unavailable) (everyone)'.length);
              text = StringHelpers.ellipsize(text, 32);
              text = text + '<i class="icon-building"></i>';
            } else {
              if (isEveryone(text)) {
                text = text.substring(0, text.length - '(everyone)'.length);
                text = StringHelpers.ellipsize(text, 32);
                text = text + '<i class="icon-building"></i>';
              }
              if (isUnavailable(text)) {
                text = text.substring(0, text.length - '(unavailable)'.length);
                text = StringHelpers.ellipsize(text, 32);
              }
            }
            if (isError(text)) {
              text = '<span class="error-text">' + StringHelpers.ellipsize(text, 32) + '</span>';
            }
          }
          return text + ' <i class="icon-dropdown-arrow"></i>';
        },
        // Replicate the native functionality on the elements so
        // that angular can handle the changes for us.
        onChange: function (optionElement, checked) {
          optionElement.prop('selected', false);
          if (checked) {
            optionElement.prop('selected', true);
          }
          element.change();
          if (scope.dropdownChange) {
            scope.dropdownChange();
          }
        },
      });

      // must tell angular-ui-bootstrap about new dropdown
      $compile(element.next())(scope);

      // Watch for any changes to the length of our select element
      scope.$watch(
        function () {
          return element[0].length;
        },
        function () {
          $timeout(function () {
            element.multiselect('rebuild');
          });
        }
      );

      // Watch for any changes from outside the directive and refresh
      scope.$watchGroup([attributes.ngModel, 'dropdownLoading', 'dropdownData'], function () {
        $timeout(function () {
          element.multiselect('refresh');
        });
      });
    },
  };
}

RadioDropdownDirective.$inject = ['$timeout', '$compile'];
